// On Dom Load
//
// Code to make working with client-side rendered HTML partials easier.
//
// Why?
// - For example, during an AJAX request you're adding a HTML form to the DOM.
// - This form has tooltips defined using the data-toggle="tooltip" attribute.
// - Tooltips are initialized using the following code:
//
//     $ ->
//       $('[data-toggle="tooltip"]').tooltip()
//
// - Because this form was added after the page was initialized, these tooltips
//   are ignored.
//
// How do? Three steps!
// - Instead of using `$ ->` you use `onDomLoad ->`.
// - Scope your jquery finder on the passed in argument:
//     onDomLoad ($dom) ->
//       $dom.find('[data-toggle="tooltip"]').tooltip()
// - Whenever you're adding a new piece to the DOM, initialize it first:
//      $form = $("<form>...</form>").initializeDom()
//
import _ from 'lodash'
import $ from 'jquery'

window.onDomLoad = function (handler) {
  $(document).on('turbolinks:load', () => handler($(document)))

  $.domProcessors.push(handler)

  if (window._domInitializedOnceAlready) {
    handler($(document))
  }
}

$(document).one(
  'turbolinks:load',
  () =>
    // We keep track of the first time DOM is initialized and next time
    // when onDomLoad is called we immediately also call the added
    // handlers because this is likely from a new JS file that a
    // particular page has asked to load and in these cases the
    // onDomLoad for that page might already have been triggered
    // before these JS files are evaluated.
    (window._domInitializedOnceAlready = true)
)

$.domProcessors = []

$.fn.initializeDom = function () {
  _.each($.domProcessors, (processor) => {
    processor(this)
  })

  return this
}
